import styled from "@emotion/styled";

export const PathName = styled.code`
  background: #000000c8;
  color: white;
  padding: 4px 6px;
  border-radius: 8px;
`;
